/**
 * TrendChart - Gráfico da referência projetada diária (60 dias)
 * vs. referências oficiais CNA/IEA publicadas
 */
import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ReferenceLine, ResponsiveContainer } from 'recharts';

const fmtBRL = (v) => `R$ ${Number(v).toFixed(2).replace('.', ',')}`;
const MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
const fmtDate = (d) => {
  const [, m, day] = d.split('-');
  return `${parseInt(day, 10)}/${MESES[parseInt(m, 10) - 1]}`;
};

export const TrendChart = ({ series, officialLines }) => {
  if (!series || series.length === 0) return null;
  const values = series.map((s) => s.projected).concat(officialLines.map((l) => l.value));
  const lo = Math.floor(Math.min(...values) * 2) / 2 - 0.5;
  const hi = Math.ceil(Math.max(...values) * 2) / 2 + 0.5;
  const ticks = [series[0]?.date, series[Math.floor(series.length / 2)]?.date, series[series.length - 1]?.date].filter(Boolean);

  return (
    <div data-testid="trend-chart" className="bg-gray-50 rounded-xl p-2">
      <p className="text-[11px] text-gray-500 font-semibold mb-1 px-1">
        Referência projetada dia a dia (últimos 60 dias) vs. oficiais publicadas
      </p>
      <ResponsiveContainer width="100%" height={210}>
        <LineChart data={series} margin={{ top: 8, right: 12, left: -14, bottom: 0 }}>
          <XAxis dataKey="date" ticks={ticks} tickFormatter={fmtDate} tick={{ fontSize: 10, fill: '#9ca3af' }} axisLine={false} tickLine={false} />
          <YAxis domain={[lo, hi]} tickFormatter={(v) => v.toFixed(1)} tick={{ fontSize: 10, fill: '#9ca3af' }} axisLine={false} tickLine={false} width={48} />
          <Tooltip
            formatter={(v) => [fmtBRL(v), 'Projeção']}
            labelFormatter={fmtDate}
            contentStyle={{ fontSize: 12, borderRadius: 8 }}
          />
          {officialLines.map((l, i) => (
            <ReferenceLine
              key={l.label}
              y={l.value}
              stroke={i === officialLines.length - 1 ? '#2563eb' : '#9ca3af'}
              strokeDasharray="5 4"
              label={{
                value: `Oficial ${l.label} — ${fmtBRL(l.value)}`,
                position: 'insideBottomLeft',
                fontSize: 9,
                fill: i === officialLines.length - 1 ? '#2563eb' : '#6b7280',
              }}
            />
          ))}
          <Line type="monotone" dataKey="projected" stroke="#16a34a" strokeWidth={2.5} dot={false} isAnimationActive={false} />
        </LineChart>
      </ResponsiveContainer>
      <p className="text-[10px] text-gray-400 mt-1 px-1">
        Linha verde: projeção do Radar (TSR-20 do dia × PTAX do dia × fator de internação calibrado).
        Tracejadas: referências oficiais CNA/IEA já publicadas.
      </p>
    </div>
  );
};
